<template>
  <div
    class="nodes__tree"
    v-for="(node, index) in botNodes"
    :key="node.id"
    :class="{ 'tree-connection-siblings': node.node && index !== botNodes.length - 1 }"
  >
    <div :class="{ 'tree-connection': node.node }">
      <NodeCard
        :node="node"
        :id="`ivr-node-${index}`"
        :parent-node="parentNode"
        @click="handleOpenDrawer"
        @delete="(ids) => emit('closeSettings', ids)"
      />
    </div>

    <div class="child__nodes__tree">
      <NodesTree
        v-if="node.child"
        :bot-nodes="node.child"
        :parent-node="node"
        @openSettings="handleOpenDrawer"
        @closeSettings="(ids) => emit('closeSettings', ids)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Node } from "@/@types/ivr";

import NodeCard from "@/app/ivr/bot/components/cards/NodeCard.vue";

defineProps<{
  botNodes: Node[];
  parentNode: Node | undefined;
}>();

const emit = defineEmits<{
  (e: "openSettings", id: number): void;
  (e: "closeSettings", ids: number[]): void;
}>();

const handleOpenDrawer = (id: number) => emit("openSettings", id);
</script>

<style scoped lang="sass">
.child__nodes__tree
  margin-left: 32px

.tree-connection
  position: relative

  &::before
    content: ""
    display: block
    position: absolute
    width: 16px
    margin-left: -16px
    height: 62%
    border-bottom-left-radius: 6px
    border-left: 1px solid $blue-3
    border-bottom: 1px solid $blue-3
    margin-top: -8px
    bottom: 50%
    pointer-events: none
    transform: translateZ(0)
    background: transparent

.tree-connection-siblings
  position: relative

  &::before
    content: ""
    display: block
    position: absolute
    width: 16px
    height: calc(100% + 20px)
    // border-bottom-left-radius: 6px
    border-left: 1px solid $blue-3
    // border-bottom: 1px solid $gray-7
    margin-left: -16px
    margin-top: -8px
    pointer-events: none
    transform: translateZ(0)
    background: transparent
</style>
